import React, { useMemo } from "react";
import { MimaText } from "../../../components";
import styles from "../../../assets/styles/Moneyex/Moneyex.module.scss";
import moment from "moment";

const OrderTracker = ({ item, isExpress }) => {
  const buyerStatus = item?.buyerStatus;
  const sellerStatus = item?.sellerStatus;
  const adminBuyerPaymentStatus = item?.adminBuyerPaymentStatus;
  const adminSellerPaymentStatus = item?.adminSellerPaymentStatus;
  const status = item?.status;
  const from = item?.from;
  const to = item?.to;

  const p2pOrderTracker = useMemo(() => {
    const steps = [
      {
        title: "Buyer Created Order",
        step: 1,
        date: item?.createdAt,
        status: "",
        done: true,
        failed: false,
      },
      {
        title: "Buyer Payment Validated in Escrow",
        step: 2,
        date: item?.buyerPaymentDateTime,
        status: buyerStatus,
        done: buyerStatus === "PAID" ? true : false,
        failed: buyerStatus === "FALSE-PAYMENT" ? true : false,
      },
      {
        title: "Seller Initiated Payment",
        step: 3,
        date:
          sellerStatus === "VALIDATION"
            ? item?.updatedAt
            : item?.sellerPaymentDateTime,
        status: sellerStatus,
        done: sellerStatus === "AWAITING" ? false : true,
        failed: sellerStatus === "FALSE-PAYMENT" ? true : false,
      },
      {
        title: "Seller Payment Validated in Escrow",
        step: 4,
        date: item?.sellerPaymentDateTime,
        status: sellerStatus,
        done: sellerStatus === "PAID" ? true : false,
        failed: sellerStatus === "FALSE-PAYMENT" ? true : false,
      },
      {
        title: ` Buyer Credited in ${from}`,
        step: 5,
        date: item?.adminBuyerPaymentDateTime,
        status: adminBuyerPaymentStatus,
        done: adminBuyerPaymentStatus === "PAID" ? true : false,
        failed: status === "FAILED" ? true : false,
      },
      {
        title: ` Seller Credited in ${to}`,
        step: 6,
        date: item?.adminSellerPaymentDateTime,
        status: adminSellerPaymentStatus,
        done: adminSellerPaymentStatus === "PAID" ? true : false,
        failed: status === "FAILED" ? true : false,
      },
      {
        title: "Transaction Complete",
        step: 7,
        date: item?.adminSellerPaymentDateTime,
        status: status,
        done: status === "COMPLETED" ? true : false,
        failed: status === "FAILED" ? true : false,
      },
    ];

    let hasFailed = false;
    return steps.map((step) => {
      if (hasFailed) {
        return { ...step, failed: true, done: false };
      }
      if (step.failed) {
        hasFailed = true;
      }
      return step;
    });
  }, [
    buyerStatus,
    sellerStatus,
    adminBuyerPaymentStatus,
    adminSellerPaymentStatus,
    status,
    from,
    to,
    item,
  ]);
  const expressOrderTracker = useMemo(() => {
    const steps = [
      {
        title: "Buyer Created Order",
        step: 1,
        date: item?.createdAt,
        status: "",
        done: true,
        failed: false,
      },
      {
        title: "Buyer Payment Validated",
        step: 2,
        date: item?.buyerPaymentDateTime,
        status: buyerStatus,
        done: buyerStatus === "PAID" ? true : false,
        failed: buyerStatus === "FALSE-PAYMENT" ? true : false,
      },
      {
        title: "Buyer Credited",
        step: 3,
        date: item?.mimaPaymentDateTime,
        status: adminBuyerPaymentStatus,
        done: adminBuyerPaymentStatus === "PAID" ? true : false,
        failed: adminBuyerPaymentStatus === "FAILED" ? true : false,
      },
      {
        title: "Transaction Complete",
        step: 4,
        date: item?.mimaPaymentDateTime,
        status: status,
        done: status === "COMPLETED" ? true : false,
        failed: status === "FAILED" ? true : false,
      },
    ];

    let hasFailed = false;
    return steps.map((step) => {
      if (hasFailed) {
        return { ...step, failed: true, done: false };
      }
      if (step.failed) {
        hasFailed = true;
      }
      return step;
    });
  }, [buyerStatus, sellerStatus, status, item, adminBuyerPaymentStatus]);

  const orderTracker = useMemo(() => {
    if (isExpress) {
      return expressOrderTracker;
    }

    return p2pOrderTracker;
  }, [isExpress, expressOrderTracker, p2pOrderTracker]);

  //   const calculateCurrentStep = (tracker) => {
  //     let currentStep = 0;
  //     tracker.forEach((item) => {
  //       if (item.done && !item.failed) {
  //         currentStep = item.step;
  //       }
  //     });
  //     return currentStep;
  //   };

  //   const currentStep = calculateCurrentStep(orderTracker);

  //   const handleReceiptDL = () => {
  //     if (isSeller) {
  //       return window.open(adminSellerPaymentProofUrls[0], "_blank");
  //     }

  //     return window.open(adminBuyerPaymentProofUrls[0], "_blank");

  //     // if (data && data.url) {
  //     //   window.open(data.url, '_blank');
  //     // } else {
  //     //   console.error('URL not found in the data');
  //     // }
  //   };

  return (
    <div className={styles.order__progress}>
      <MimaText variant="subtitleBold" align="center">
        Order Tracker
      </MimaText>
      <div className={styles.order__progress__steps}>
        <div className={styles.order__progress__steps__line}></div>
        {orderTracker.map((order, i) => (
          <div key={i} className={styles.order__progress__step}>
            <div
              className={`${styles.order__progress__steps__num} ${order.failed ? styles.order__progress__steps__num__failed : order.done ? styles.order__progress__steps__num__active : ""}`}
            >
              {order.step}
            </div>
            <div>
              <MimaText variant="small">
                {order.title}
                {/* {order.step === 3 &&
                  !order.done &&
                  //   isSeller &&
                  currentStep === 2 && (
                    <MimaButton
                      title="Verify Payment"
                      mt={1}
                      //   onClick={() => {
                      //     setShowVerifyPayment(true);
                      //   }}
                    />
                  )} */}
              </MimaText>
              {order?.date && (
                <MimaText variant="xsmall" mt={0.5}>
                  {moment(order?.date).format("DD/MM/YY HH:mm A")}
                </MimaText>
              )}
              {order?.failed && (
                <MimaText variant="xsmall" mt={0.5} color="var(--color-error)">
                  {order.status}
                </MimaText>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderTracker;
